/**
 * PATH: packages/ui/src/components/global-search/searchRankFlag.ts
 * FILE_ID: UI-GLOBALSEARCH-RANKFLAG-001
 * PURPOSE: Single source of truth for the email relevance-ranking opt-in
 *          (`?rank=1` on /api/emails/?search=) + its operator kill switch.
 * WHY: be!4448 made relevance ordering OPT-IN and pins recency as the
 *      backend default, so the FE flip must be revocable WITHOUT a deploy.
 *      LANDMINE: the flag is read per-request, not cached ? a support
 *      operator can set localStorage and the very next search reverts to
 *      recency. Do not memoise the read.
 * RELATED:
 *  - providers/email.ts (palette call site), email-hub useEmails
 *    queryString (inbox call site) ? both MUST go through this helper.
 */

/** Set this localStorage key to '1' to disable relevance ranking
 *  (searches fall back to the backend's pinned recency default). */
export const SEARCH_RANK_DISABLED_KEY = 'qt-search-rank-disabled'

/**
 * f(kill-switch state) ? the value to send as the `rank` query param on
 * email search requests, or `undefined` to omit the param entirely.
 * Default ON ('1'); storage failures (SSR, sandboxed iframe, disabled
 * storage) also default ON ? the backend fail-softs unknown values.
 */
export function getSearchRankParam(): '1' | undefined {
  try {
    if (typeof window === 'undefined') return '1'
    if (window.localStorage.getItem(SEARCH_RANK_DISABLED_KEY) === '1') {
      return undefined
    }
  } catch {
    /* storage unavailable ? stay on the default */
  }
  return '1'
}
